import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./reducers/auth";
import organizationReducer from "./reducers/organizationSlice";
import roleReducer from "./reducers/roleSlice";
import userOrganizationsReducer from "./reducers/userOrganizationsSlice";
import badgesReducer from "./reducers/badgesDetails";
import employeePerformanceOverviewReducer from "./reducers/employeePerformanceOverview";
import rewardDashboardReducer from "./reducers/rewardDashboard";
import notificationReducer from "./reducers/notification";
import userPermissionsReducer from "./reducers/userPermissionSlice";
import leaderBoardReducer from "./reducers/leaderBoard";
import graphDataReducer from "./reducers/graphDataSlice";
import q2m2ApplicationsReducer from "./reducers/q2m2ApplicationsSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    organization: organizationReducer,
    role: roleReducer,
    userOrganizations: userOrganizationsReducer,
    badgesDetails: badgesReducer,
    employeePerformanceOverview: employeePerformanceOverviewReducer,
    rewardDashboard: rewardDashboardReducer,
    notifications: notificationReducer,
    userPermissions: userPermissionsReducer,
    leaderBoard: leaderBoardReducer,
    graphData: graphDataReducer,
    q2m2Applications: q2m2ApplicationsReducer,
  },
});

export default store;
